import "./HoaTreeCare.module.css";
import Header from "@/reusable_sections/Header";
import HoaTreeCareHero from "./sections/HoaTreeCareHero";
import HoaServiceOverview from "./sections/HoaServiceOverview";
import HoaPrograms from "./sections/HoaPrograms";
import RiskAssessmentServices from "./sections/RiskAssessmentServices";
import ColleyvilleFortWorthFocus from "./sections/ColleyvilleFortWorthFocus";
import GetYourFreeHoaAssessment from "./sections/GetYourFreeHoaAssessment";
import Footer from "@/reusable_sections/Footer";
export default function HoaTreeCarePage() {
  return <div>
      <Header />
      <HoaTreeCareHero />
      <HoaServiceOverview />
      <HoaPrograms />
      <RiskAssessmentServices />
      <ColleyvilleFortWorthFocus />
      <GetYourFreeHoaAssessment />
      <Footer />
    </div>;
}